<template>
  <div class="left_side">
      <div class="input_top">
        <div class="flex_style left">
          <v-text-field
            hide-details="auto"
            label=""
            placeholder="过滤关键词"
            outlined
            append-icon="mdi-magnify"
            v-model="fitlerSec"
            @click:append="getSecondKey"
            @keyup.enter="getSecondKey"
          >
          <!-- :value="filterKey" -->
          </v-text-field>
            <div class="sm_icon">
              <span v-if="labelKey=='AND'" @click="showLabelKey=true">AND <v-icon>mdi-triangle</v-icon></span>
              <span v-if="labelKey=='OR'" @click="showLabelKey=true">OR <v-icon>mdi-triangle</v-icon></span>
              <span v-if="labelKey=='NOT'" @click="showLabelKey=true">NOT <v-icon>mdi-triangle</v-icon></span>
              <div class="sm_list" v-if="showLabelKey">
                <div :class="{'item': true,'active': labelKey=='AND'}" @click="setLabelKey('AND')">AND</div>
                <div :class="{'item': true,'active': labelKey=='OR'}" @click="setLabelKey('OR')">OR</div>
                <div :class="{'item': true,'active': labelKey=='NOT'}" @click="setLabelKey('NOT')">NOT</div>
              </div>
            </div>
          <!-- <v-icon class="menu_icon hand">mdi-filter</v-icon> -->
        </div>
      </div>
      <div class="filter_box">
        <div class="tit" v-if="secondTemp || saveFilterData.length>0">已选过滤项</div>
        <div class="box_list" style="padding: 0;">
            <div class="item" v-if="secondTemp">
                <div class="close_icon">
                  <v-icon @click="clearSec">mdi-close</v-icon>
                </div>
                <div class="box_top">
                      <div class="opt flex_style left">
                        <span class="text1">二次筛选</span>
                      </div>
                </div>
                <div class="flex_style betw">
                  <div class="text2">{{secondTemp}}</div>
                </div>
            </div>
            <div v-for="(item, index) in saveFilterData" :key="index">
                <div class="item">
                    <div class="close_icon" v-if="item.type1 == 'sel'">
                      <v-icon @click="clearFilter('sel')">mdi-close</v-icon>
                    </div>
                    <div class="close_icon" v-else>
                      <v-icon @click="clearFilter(index)">mdi-close</v-icon>
                    </div>
                    <div class="box_top">
                      <div class="opt flex_style left">
                        <span class="text1">{{item.op =='include'?'包含': '排除'}}</span><i></i> 
                        <div class="pName" :title="getNameByKey(item.type)">{{getNameByKey(item.type)}}</div>
                      </div>
                    </div>
                    <div class="line flex_style betw" v-for="(item2,index2) in item.values" :key="index2">
                      <div v-if="item2" class="text2">
                        {{item2}}
                      </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
        <v-expansion-panels accordion>
          <v-expansion-panel @click="aggs('countryCode')">
              <v-expansion-panel-header>国家筛选</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div>
                   <div v-for="(item,index) in countryFilter.slice(0, num)" :key="index">
                      <v-list>
                          <v-list-item>
                            <template v-slot>
                              <v-list-item-action>
                                  <v-checkbox :input-value="item.total" :indeterminate="check1[item.key]" v-model="check[item.key]" color="primary"></v-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                  <v-list-item-title :title="item.name+'--' + item.docCount">
                                  {{ item.name }} ({{ item.docCount }})
                                  </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                          <div style="padding:0 8px;">
                            <v-list-item-group
                              v-model="selectedCountry[item.key]"
                              multiple
                              color="primary"
                              >
                                <!-- @change="changeChk" -->
                                <v-list-item v-for="b in item.children[0].buckets" :key="b.key" :value="item.key +'_'+b.key">
                                    <template v-slot:default="{active}">
                                    <v-list-item-action>
                                        <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title :title="b.key+'--' + b.docCount">
                                        {{ b.key }} ({{ b.docCount }})
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    </template>
                                </v-list-item>
                            </v-list-item-group>
                          </div>
                      </v-list>
                   </div>
                   <div class="filter_panel_btns">
                      <div class="more_icon" v-if="num< countryFilter.length" @click="num = num+10">
                        <span>更多</span>
                        <v-icon>mdi-chevron-double-right</v-icon>
                      </div>
                      <div class="more_icon" v-else  @click="num = 10">
                        <span>收起</span>
                        <v-icon>mdi-chevron-double-left</v-icon>
                      </div>
                      <div class="filter_btns">
                        <span class="btn" @click="changeChk('include')">包含</span>
                        <span class="btn" @click="changeChk('exclude')">排除</span>
                      </div>
                    </div>
                </div>
              </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- multiple -->
          <v-expansion-panel v-for="item in defauleSearchSchema.defaultFilter"  :key="item.key"  @click="aggs(item.key)">
            <v-expansion-panel-header>{{item.label}}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- :eager="eager" -->
                  <v-skeleton-loader
                  v-if="$store.state.loadingCount>0"
                  v-bind="attrs"
                  type="list-item-two-line">
                  </v-skeleton-loader>
                  <v-list v-else-if="(!getSavedSearchSchema(item.key)||getSavedSearchSchema(item.key).length<=0)">
                    <v-list-item>
                      <v-list-item-title>暂无数据</v-list-item-title>
                    </v-list-item>
                  </v-list>
                  <div v-else-if="getSavedSearchSchema(item.key)">
                    <v-list>
                        <v-list-item-group
                            v-model="selectedItem[item.key]"
                            multiple
                            color="primary"
                            >
                            <!-- @change="changeChk" -->
                            <v-list-item v-for="b in getSavedSearchSchema(item.key).slice(0, num)" :key="b.key" :value="b.key">
                                <template v-slot:default="{active}">
                                <v-list-item-action>
                                    <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title :title="b.key+'--' + b.docCount">
                                    {{ b.key }} ({{ b.docCount }})
                                    </v-list-item-title>
                                </v-list-item-content>
                                </template>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                    <div class="filter_panel_btns">
                      <div class="more_icon" v-if="num< getSavedSearchSchema(item.key).length" @click="num = num+10">
                        <span>更多</span>
                        <v-icon>mdi-chevron-double-right</v-icon>
                      </div>
                      <div class="more_icon" v-else  @click="num = 10">
                        <span>收起</span>
                        <v-icon>mdi-chevron-double-left</v-icon>
                      </div>
                      <div class="filter_btns">
                        <span class="btn" @click="changeChk('include')">包含</span>
                        <span class="btn" @click="changeChk('exclude')">排除</span>
                      </div>
                    </div>
                  </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import Vue from 'vue'
export default {
    props: ['keyValue'],
  data() {
    return {
      num: 10,
      show: false,
      fcKey: [],
      aggsKey: '',
      slength: {},
      showed: [],
      selectedItem: {},
      saveFilterData: [],
      selectedKey: [],
      selected: [],
      eager: false,
      absolute: false,
      activeKey: '',
      //q=石墨烯&f=applicant
      filterKey: "",
      messages: "过滤关键词",
      index: 0,
      selectKey: [],
      child: false,
      tree: [],
      initiallyOpen: [],
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2,
      },
      files: {
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-code-json",
        md: "mdi-language-markdown",
        pdf: "mdi-file-pdf",
        png: "mdi-file-image",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
      },
      items: [
        {
          name: "文件1",
        },
        {
          name: "文件2",
          children: [
            {
              name: "static",
              children: [
                {
                  name: "logo.png",
                  file: "png",
                },
              ],
            },
            {
              name: "石墨烯",
            },
            {
              name: "index.html",
              file: "html",
            },
          ],
        },
      ],
      selectedCountry: {},
      check: {},
      check1: {},
      showLabelKey: false,
      labelKey: 'AND',
      fitlerSec: '',
      secondTemp: ''
    };
  },
  watch: {
        selected(val) {
            console.log('val', val)
        },
        saveFilterData1(val) {
          if(val) {
            this.saveFilterData = val
          }
        },
        keyValue(val) {
          if(this.filterKey != val) {
            this.showed = []
          }
          this.filterKey = val
        },
        slength(val) {
          console.log('dddd', val)
        },
        selectedCountry: {
          deep: true,
          handler:function(newV,oldV){
            this.countryFilter.forEach((item)=>{
              if(newV[item.key]) {
                if(newV[item.key].length == item.total.length) {
                  this.$set(this.check,item.key,true)
                  this.$set(this.check1,item.key,false)  
                }else if(newV[item.key].length >0){
                  this.$set(this.check1,item.key,true)  
                }else {
                  this.$set(this.check,item.key,false)  
                  this.$set(this.check1,item.key,false)  
                }
              }
            })
          }
        },
        check:{ 
          deep:true, 
          handler:function(newV,oldV){
            for(let i in newV) {
              if(newV[i]&&newV[i]==true) {
                this.countryFilter.forEach((item)=>{
                    if(item.key == i) {
                      this.$set(this.selectedCountry,i,item.total) 
                    }
                })
              }else {
                this.selectedCountry[i] = []
                // this.$set(this.selectedCountry,i,'')
              }
            }
          }
        },
        countryChange(val) {
          if(val) {
            this.$store.commit('setCountryChange', false)
            this.aggs('countryCode','update')
          }
        }
  },
  created() {
      if(this.$route.query.from && this.$route.query.from=='search') {
        let saveFilterData = JSON.parse(sessionStorage.getItem('saveFilterData'))
        this.$store.commit('setAnalyFilter', saveFilterData)
        this.fcKey = saveFilterData
        this.$emit('filterChange', this.fcKey) 
      }else {
        if(sessionStorage.getItem('analyFilterData')) {
            let saveFilterData = JSON.parse(sessionStorage.getItem('analyFilterData'))
            this.$store.commit('setAnalyFilter', saveFilterData)
            this.fcKey = saveFilterData
            this.$emit('filterChange', this.fcKey) 
        }
      }
  },
  mounted() {
      this.filterKey = this.$route.query.str
  },
  methods: {
    ...mapMutations("search", [
      "upsertSavedSearchSchema",
      "setSavedSearchSchemas",
    ]),
    ...mapActions("search", ["queryAggs"]),
    aggs(key, update) {
      let country = []
      let ds = 'cn'
      if(localStorage.getItem('countries1')) {
        country = JSON.parse(localStorage.getItem('countries1'))
        let newData = []
        if(country.length==1) {
          ds = country[0]
        }else {
          ds = 'all'
          let list = ['发明公开','发明授权','实用新型','外观设计']
          let list1 = ['发明申请','发明授权','再颁专利','外观设计',' 依法登记的发明','植物专利']
          let newArr = []
          if(country.length>=2 && country.length<116) {
            country.forEach((item)=>{
              item = item.toUpperCase()
              let name = []
              if(item !='US') {
                list.forEach((item1)=>{
                  name.push(item+'_'+item1)
                })
              }else {
                list1.forEach((item1)=>{
                  name.push(item+'_'+item1)
                })
              }
              newArr = newArr.concat(name)
            })
              let temp = {
                  type: 'type',
                  type1: 'sel',
                  op: 'include',
                  values: newArr
              }
              newData.push(temp)  
          }
        }
        if(this.fcKey.length>0) {
          this.fcKey.forEach((item,index)=>{
            if(item.type == 'type') {
              this.fcKey.splice(index, 1)
            }
          })
        }
        this.fcKey = this.fcKey.concat(newData)
        this.saveFilterData = this.fcKey
        this.$store.commit('setAnalyFilter', this.saveFilterData)
        this.$emit('filterChange', this.fcKey) 
      } 
      this.num = 10
      this.aggsKey = key
      let fcKey = this.fcKey.length>0?JSON.stringify(this.fcKey): ''
      if(!this.showed[key] || update) {
          this.showed[key] = true
          this.activeKey = key
          let postData = { 
            q: this.filterKey, 
            f: key ,
            ps:10,
            fc: fcKey,
            wfId: '',
            ds: ds
          };
          // this.$store.state.folderId
          this.selectedItem = []
          this.selectedCountry = {}
          this.check = {}
          this.check1 = {}
          this.queryAggs({ params: postData });
      }    
       
    },
    handelSelectKey() {
      console.log("selectKey", this.selectKey);
    },
    changeChk(val) {
        let fcKey1 = []
        let obj1 = {...this.selectedCountry}
        let list = {}
        let newArr = []
        for(let n in obj1) {     
          if(obj1[n]) {
            newArr = newArr.concat(obj1[n])
          }
        }
        if(newArr.length>0) {
          list.type = 'type'
          list.op = val
          list.values = newArr
          fcKey1.push(list)
        }
        let obj = {...this.selectedItem}
        // this.selectedItem1 = JSON.parse(obj)
        let saveObj = {
          filter: obj,
          opt: val
        }
        let fcKey = []
        for(let i in obj) {
            let list = {}
            list.type = i
            list.op = val
            list.values = obj[i]
            fcKey.push(list)
        }
        if(val == 'none') {
          fcKey = []
        }
        // let fcKey = this.fcKey
        let key1 = fcKey.concat(fcKey1)
        this.fcKey = this.fcKey.concat(key1)
        this.saveFilterData = this.fcKey
        this.$store.commit('setAnalyFilter', this.saveFilterData)
        this.$emit('filterChange', this.fcKey) 
        this.aggs(this.aggsKey, 'update')
    },
    clearFilter(index) {
      if(index == 'sel') {
        localStorage.removeItem('countries1')
      }
      this.showed = []
      this.saveFilterData.splice(index,1)
      this.$emit('filterChange', this.saveFilterData) 
      this.$store.commit('setAnalyFilter', this.saveFilterData)
      this.aggs(this.aggsKey, 'update')
    },
    getNameByKey(key) {
      let totalList = this.totalList
      let name = ''
      totalList.forEach((item)=>{
        if(item.key == key) {
          name = item.label
        }
      })
      return name
    },
    setLabelKey(val) {
      this.labelKey = val
      this.showLabelKey = false
    },
      getSecondKey() {
        let totalTemp = this.secondTemp
        let label = this.labelKey
        let second = this.fitlerSec
        if(!second) {
          this.$message({
            type: 'info',
            message: '请输入关键词'
          })
          return false
        }
        this.fitlerSec = ''
        let temp = label + '('+ second + ') '
        totalTemp = totalTemp + temp
        if(totalTemp.indexOf('AND')=='0' || totalTemp.indexOf('OR')=='0' || totalTemp.indexOf('NOT')=='0') {
            totalTemp = totalTemp.slice(3)
        }
        this.secondTemp = totalTemp
        this.$store.commit('setAnalySecondKey', second)
        this.aggs(this.aggsKey, 'update')
        this.$emit('secondFilter', this.secondTemp) 
      },
      clearSec() {
        this.secondTemp = ''
        this.$emit('secondFilter', this.secondTemp) 
        this.aggs(this.aggsKey, 'update')
      },
  },
  computed: {
    ...mapGetters("search", {
      defauleSearchSchema: "defauleSearchSchema",
      savedSearchSchemas: "savedSearchSchemas",
      getSavedSearchSchema: "getSavedSearchSchema",
      loading: state=>state.loadingCount>0?true:false,
      countryFilter: "countryFilter"
    }),
    saveFilterData1() {
        return this.$store.state.analyFilterData
    },
    ...mapState("search", {
      totalList: state => state.defauleSearchSchema.defaultFilter,
    }),
    countryChange() {
      return this.$store.state.countryChange
    }
  },
};
</script>